var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ActivityWithdrawal"},[_c('withdrawalList',{attrs:{"param":_vm.param,"flag":_vm.flag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }